import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const SignGuard = ({ children }) => {
  const authToken = localStorage.getItem("authToken");

  const location = useLocation();

  if (
    authToken &&
    (location.pathname.includes("signin") ||
      location.pathname.includes("signup") ||
      location.pathname.includes("reset-password") ||
      location.pathname.includes("forget-password") ||
      location.pathname.includes("otp"))
  ) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default SignGuard;
